import { render } from "./PhotoView.vue?vue&type=template&id=447d8da3"
import script from "./PhotoView.vue?vue&type=script&lang=js"
export * from "./PhotoView.vue?vue&type=script&lang=js"

import "./PhotoView.vue?vue&type=style&index=0&id=447d8da3&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__